module.exports = __webpack_public_path__ + "img/APEC.e0f81c3f.jpg";